import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

const categories = [
  { id: "all", name: "All Books" },
  { id: "architecture", name: "Architecture" },
  { id: "art", name: "Art" },
  { id: "biographies", name: "Biographies" },
  { id: "economics", name: "Economics & Politics" },
  { id: "history", name: "History" },
  { id: "technology", name: "Technology" },
  { id: "philosophy", name: "Philosophy" },
  { id: "science", name: "Science" },
];

interface CategorySidebarProps {
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
}

export function CategorySidebar({ selectedCategory, onSelectCategory }: CategorySidebarProps) {
  return (
    <div className="w-64 shrink-0 border-r">
      <ScrollArea className="h-full py-4">
        <div className="space-y-1 px-2">
          {categories.map((category) => (
            <Button
              key={category.id}
              variant={selectedCategory === category.id ? "secondary" : "ghost"}
              className={cn(
                "w-full justify-start",
                selectedCategory === category.id && "bg-muted"
              )}
              onClick={() => onSelectCategory(category.id)}
            >
              {category.name}
            </Button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}